<mat-expansion-panel [(expanded)]="expanded" #panel hideToggle>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <mat-icon [@iconRotate]="panel.expanded ? 'expanded' : 'collapsed'"> arrow_right </mat-icon>
      <ng-content select="[title]"></ng-content>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ng-content></ng-content>
</mat-expansion-panel>
